import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const SideLayoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  z-index: 1;
  margin-top: -50px;
  ${mediaQuery('medium')} {
    flex-direction: column;
  }
`;

export const SideLayoutStickyWrapper = styled.div<{ marginBottom: number }>`
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  top: 100px;
  position: sticky;
  margin-bottom: ${(props) => (props.marginBottom ? `${props.marginBottom}px` : '50px')};
`;

export const SideLayoutContentWrapper = styled.div`
  flex: 1;
  width: 0;
  position: relative;
  padding-right: 50px;
  padding-top: 0px;
  ${mediaQuery('medium')} {
    width: 100%;
    padding: 20px;
  }
  ${mediaQuery('phone')} {
    padding: 0;
  }
`;

export const SideLayoutSideWrapper = styled.div`
  /* width: 32%; */
  width: 450px;
  flex-shrink: 0;
  position: relative;
  ${mediaQuery('medium')} {
    width: 100%;
    order: -1;
  }
`;
